<template>
  <van-overlay
    z-index="2099"
    :show="show"
    @click="onClickOverlay"
    class="pcDialogOverlay"
  >
    <div class="pcDialog" @click.stop>
      <div class="pcDialogContent" :style="dialogStyle">
        <div class="titleGroup">
          <div class="pcDialogTitle" v-if="title">
            <span>{{ title }}</span>
          </div>
          <div class="pcDialogSubtitle" v-if="subtitle">
            <span>{{ subtitle }}</span>
          </div>
        </div>
        <div class="pcDialogBody" v-if="$slots.pcDialogBody">
          <slot name="pcDialogBody"></slot>
        </div>
        <div class="pcDialogFooter">
          <slot name="footer">
            <div class="buttonGroup">
              <div
                v-if="showCancelButton"
                class="cancelButton"
                :class="{
                  'cancelButton-custom-hover': cancelButtonHoverBgColor,
                  'cancelButton-custom-active': cancelButtonActiveBgColor
                }"
                :style="{
                  color: cancelButtonTextColor,
                  backgroundColor: cancelButtonBgColor,
                  borderColor: cancelButtonBorderColor || cancelButtonBgColor,
                  ...(cancelButtonHoverBgColor && { '--cancel-hover-bg-color': cancelButtonHoverBgColor }),
                  ...(cancelButtonActiveBgColor && { '--cancel-active-bg-color': cancelButtonActiveBgColor })
                }"
                @click="onCancel"
              >
                {{ cancelButtonText }}
              </div>
              <div
                v-if="showConfirmButton"
                class="confirmButton"
                :class="{
                  confirmButtonDisabled: confirmButtonDisabled,
                  'confirmButton-custom-hover': confirmButtonHoverBgColor,
                  'confirmButton-custom-active': confirmButtonActiveBgColor,
                }"
                :style="{
                  color: confirmButtonTextColor,
                  backgroundColor: confirmButtonBgColor,
                  borderColor: confirmButtonBorderColor || confirmButtonBgColor,
                  ...(confirmButtonHoverBgColor && {
                    '--hover-bg-color': confirmButtonHoverBgColor,
                  }),
                  ...(confirmButtonActiveBgColor && {
                    '--active-bg-color': confirmButtonActiveBgColor,
                  }),
                }"
                @click="onConfirm"
              >
                {{ confirmButtonText }}
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "350px",
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    cancelButtonText: {
      type: String,
      default: "取消",
    },
    confirmButtonText: {
      type: String,
      default: "确认",
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    cancelButtonTextColor: {
      type: String,
      default: "#28282D",
    },
    cancelButtonBgColor: {
      type: String,
      default: "#FFFFFF",
    },
    cancelButtonHoverBgColor: {
      type: String,
      default: "",
    },
    cancelButtonActiveBgColor: {
      type: String,
      default: "",
    },
    cancelButtonBorderColor: {
      type: String,
      default: "#E5E7EB",
    },
    confirmButtonTextColor: {
      type: String,
      default: "#FFFFFF",
    },
    confirmButtonBgColor: {
      type: String,
      default: "#1F2937",
    },
    confirmButtonHoverBgColor: {
      type: String,
      default: "",
    },
    confirmButtonActiveBgColor: {
      type: String,
      default: "",
    },
    confirmButtonBorderColor: {
      type: String,
      default: "",
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dialogStyle() {
      // 计算最大宽度（视窗宽度减去左右各20px的边距）
      const maxWidth = `calc(100vw - 80px)`;

      // 如果传入的是数字，添加px单位
      let widthValue =
        typeof this.width === "number" ? `${this.width}px` : this.width;

      return {
        width: widthValue,
        maxWidth: maxWidth,
      };
    },
  },
  methods: {
    onClickOverlay() {
      if (this.closeOnClickOverlay) {
        // this.$emit('cancel');
        // this.$emit('update:show', false);
      }
    },
    onCancel() {
      this.$emit("cancel");
      this.$emit("update:show", false);
    },
    onConfirm() {
      this.$emit("confirm");
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./pcDialog.scss";
</style>
